import {Box, Typography} from "@mui/material";
import {FONT_PRIMARY, FONT_SECONDARY} from "@/theme/typography.ts";
import Field from "@/components/RHFcomponents/Field";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import PhoneInput from "@/components/RHFcomponents/PhoneInput";
import {useGetCountriesAndStatesQuery} from "@/redux-store/api/marketingApi.ts";
import {getCountriesAndStatesOptions} from "@/utils/forms/getCountriesAndStatesOptions.ts";
import {UseFormReturn} from "react-hook-form";

interface IProp {
    checkboxInput: boolean;
    isUSAselected: boolean;
    control: UseFormReturn<ICheckoutForm, unknown, undefined>["control"];
}

const CheckBoxStep = ({ checkboxInput, isUSAselected, control } : IProp) => {
    const { data } = useGetCountriesAndStatesQuery({});
    const { countryOptions, stateOptions } = getCountriesAndStatesOptions(data);
    const gap = { xs: 2, md: 3 };

        return (
            <>
                {!checkboxInput && (
                    <Box>
                        <Typography
                            fontSize={{ xs: "1.125rem", md: "1.25rem" }}
                            fontWeight={700}
                            fontFamily={{ xs: FONT_PRIMARY, md: FONT_SECONDARY }}
                            mb={3}
                        >
                            Provide billing information
                        </Typography>
                        <Box display="flex" gap={gap} flexDirection="column">
                            <Box display="flex" justifyContent="space-between" gap={gap}>
                                <Field
                                    name="billingFirstName"
                                    control={control}
                                    placeholder="Your first name"
                                />
                                <Field
                                    name="billingLastName"
                                    control={control}
                                    placeholder="Your last name"
                                />
                            </Box>
                            <Field
                                name="billingCompanyName"
                                control={control}
                                placeholder="Company name"
                            />
                            <Field
                                name="billingEmail"
                                control={control}
                                placeholder="Your email"
                            />
                            <Field
                                name="billingStreetAddress"
                                control={control}
                                placeholder="Your street name and number"
                            />
                            <Box display="flex" justifyContent="space-between" gap={gap}>
                                <Field
                                    name="billingCity"
                                    control={control}
                                    placeholder="Your city / town"
                                />
                                <Field
                                    name="billingZipCode"
                                    control={control}
                                    placeholder="Your ZIP code"
                                />
                            </Box>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                gap={gap}
                                sx={{
                                    "& .MuiFormControl-root:last-of-type": {
                                        display: isUSAselected ? "block" : "none",
                                    },
                                }}
                            >
                                {countryOptions.length > 0 && (
                                    <DropdownInput
                                        name="billingIdCountry"
                                        control={control}
                                        options={countryOptions}
                                        placeholder="Your country"
                                    />
                                )}
                                {stateOptions.length > 0 && (
                                    <DropdownInput
                                        name="billingIdState"
                                        placeholder="Your State"
                                        control={control}
                                        options={stateOptions}
                                    />
                                )}
                            </Box>
                            <PhoneInput
                                name="billingPhoneNumber"
                                control={control}
                                placeholder="Your phone"
                            />
                        </Box>
                    </Box>
                )}
            </>
        );
    };


export default CheckBoxStep;